<template>
  <section>
    <div class="card mt-4">
      <div class="card-body">
        <LoadingSpinner v-if="onBoarding.loading" />
        <Step1  :addOrder="addOrder" v-if="onBoarding.step == 1 && !onBoarding.loading" />
        <Step2 v-if="onBoarding.step == 2 && !onBoarding.loading" />
        <Step3
          :typeForm="typeForm"
          v-if="onBoarding.step == 3"
          :addOrder="addOrder"
          :targetId="targetId"
          :simplify="simplifyVersion"
        />
        <div
          class="row mt-5"
          v-if="onBoarding.step != 3 && onBoarding.substep != 0"
        >
          <div class="col-12">
            <div class="row">
              <div class="col-md-4">
                <button
                  v-if="onBoarding.substep == 1 && onBoarding.step == 1"
                  class="btn btn-light btn-sm"
                  @click="getToStep(1, 0)"
                >
                  {{ $t("lang.onBoarding.back_to_start") }}
                </button>
                <button class="btn btn-light btn-sm" @click="getToStep(1,1)" v-else>
                  {{ $t("lang.onBoarding.go_back_campaign_creation") }}
                </button>
              </div>
              <div class="col-md-4 text-center" v-if="!onBoarding.loading">
                <button
                  class="
                    btn
                    large
                    cursor-pointer
                    font-weight-bolder
                    btn-sm btn-outline-dark
                    mx-1
                    px-4
                  "
                  v-if="onBoarding.showback"
                  type="button"
                  @click="back()"
                >
                  {{ $t("lang.button.back") }}
                </button>
                <button
                  class="
                    btn
                    large
                    cursor-pointer
                    font-weight-bolder
                    btn-sm btn-primary
                    mx-1
                    px-4
                  "
                  v-if="onBoarding.shownext"
                  type="button"
                  :disabled="onBoarding.loading || onBoarding.disablednext"
                  @click="next()"
                  data-toggle="tooltip" 
                  data-placement="bottom" 
                  :title="$t('lang.onBoarding.completeabovequestion')"
                >
                  {{ $t("lang.button.next") }}
                   <span v-if="onBoarding.loading"
                         class="icon-save"></span>
                </button>
                <small
                  class="
                    cursor-pointer
                    mx-1
                  "
                  v-if="false"
                  type="button"
                  @click="skip()"
                >
                  {{ $t("lang.label.skip") }}
                </small>
              </div>

              <div class="col-md-4" v-if="!onBoarding.loading">
                <button
                  class="btn btn-light btn-sm 
                    float-right"
                  @click="getToStep(onBoarding.step + 1)"
                >
                  {{ $t("lang.onBoarding.skip_step") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="onBoarding.step == 3">
      <div class="card my-3"> 
        <div class="card-header" id="contractheader">
          <h5 class="mb-0">
            <button
              class="btn btn-link btn-sm"
              type="button"
              data-toggle="collapse"
              data-target="#contracts"
              aria-expanded="true"
              aria-controls="contracts"
            >
              {{ $t("lang.onBoarding.contracts_detail") }}
            </button>
          </h5>
        </div>

        <div
          v-if="!onBoarding.loading"
          id="contracts"
          class="collapse card-body my-2"
          aria-labelledby="contractheader"
        >
          <contractDetails />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Step1 from "@/components/Onboarding/MultiSteps/Step1.vue";
import Step2 from "@/components/Onboarding/MultiSteps/Step2.vue";
import Step3 from "@/components/Onboarding/MultiSteps/Step3.vue";
import contractDetails from "@/components/Onboarding/ContractDetails.vue";
import { mapState, mapActions } from "vuex";
import { targetsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";


export default {
  data() {
    return {
      simplifyVersion:false,
    };
  },

  props: {
    targetId: false,
    simplify: false,
    addOrder: false,
    typeForm: false
  },
  components: {
    Step1,
    Step2,
    Step3,
    contractDetails,
    LoadingSpinner
  },

  computed: {
    ...mapState({
      onBoarding: (state) => state.onboarding,
      disabledskip: (state) => state.onboarding.disabledskip,
    }),
  },
  mounted() {
    if(!this.onBoarding.completeLoadingTarget){
      this.$store.dispatch("optionsList/getAllTargetParams");
    }    
    
  },
  created() {
    if (this.addOrder) {
      this.simplifyVersion = this.simplify
      this.clean();
    }
  },
  methods: {
    ...mapActions("onboarding", {
      next: "next",
      skip: "skip",
      back: "back",
      setStep: "goToStep",
      setSubStep: "goToSubStep",
      clean: "clean",
      setLanguageId: "setLanguageId",
      updateOrderName: "updateOrderName",
    }),
    getToStep(step, subStep = 1) {
      this.setStep(step);
      this.setSubStep(subStep);
    },    
  },
};
</script>
